module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "barra-brasil"
    }
  }, [_c('ul', {
    staticStyle: {
      "list-style": "none"
    },
    attrs: {
      "id": "menu-barra-temp"
    }
  }, [_c('li', {
    staticStyle: {
      "display": "inline",
      "float": "left",
      "padding-right": "10px",
      "margin-right": "10px",
      "border-right": "1px solid #EDEDED"
    }
  }, [_c('a', {
    staticStyle: {
      "font-family": "sans,sans-serif",
      "text-decoration": "none",
      "color": "white"
    },
    attrs: {
      "href": "http://brasil.gov.br",
      "target": "_blank"
    }
  }, [_vm._v("Portal do Governo Brasileiro")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bab4021","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/layouts/BarraGoverno.vue
// module id = 461
// module chunks = 0